import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream py-16 sm:py-20" aria-labelledby="faq-heading" data-id="element-79" data-mp="1lc231ky1rhuv">
      <div className="mx-auto max-w-3xl px-5" data-id="element-80" data-mp="1ge8rsdhvzxnq">
        <p className="font-sans text-xs font-bold uppercase tracking-[0.24em] text-gold" data-id="element-81" data-mp="2e066s0x25kux">
          Frequently asked questions
        </p>
        <h2 id="faq-heading" className="mt-4 font-display text-3xl font-semibold leading-tight tracking-tight text-espresso sm:text-4xl" data-id="element-82" data-mp="292o6t010qfz2">
          Before you decide
        </h2>

        <ul className="mt-8 divide-y divide-espresso/10 border-y border-espresso/10" data-id="element-83" data-mp="1z2nit0s7fboj">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} data-id="element-84" data-mp="nmgu4x9ir68f" data-mpi={index}>
                <h3 data-id="element-85" data-mp="phy0xiwrfztd">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-6 py-5 text-left font-sans text-lg font-semibold text-espresso transition-colors duration-150 ease-out hover:text-gold focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" data-id="element-86" data-mp="phefvtbtcvb4">
                    {faq.question}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-87" data-mp="3sywqg8iz0gf8" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-88" data-mp="3nyig2jtwcue1">
                  {isOpen ? <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-89" data-mp="1uhct1lsty6c7">
                      <p className="pb-5 pr-10 font-sans text-base leading-relaxed text-cocoa" data-id="element-90" data-mp="2dfysyxcm1rej">
                        {faq.answer}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}